/**
 * Centralized drone data for detail pages.
 * Source: Autel Robotics product pages.
 * Multi-rotor: EVO Lite Enterprise, EVO Max 4T/4N, Autel Alpha, EVO II Enterprise/Dual 640T/RTK/Pro V3
 * eVTOL: Dragonfish-25, Dragonfish Pro, Dragonfish Standard
 */

export const DRONES_DATA = [
  // ——— Multi-rotor ———
  {
    slug: "evo-lite-enterprise-series",
    categorySlug: "multirotor",
    key: "evo_lite_enterprise",
    youtubeId: "1MwBSeCUb7w",
    autelUrl: "https://www.autelrobotics.com/productdetail/evo-lite-enterprise-series/",
    image: "/drone_images/EVOLiteEnterpriseSeries.png",
    tagline: "drones_catalog.items.evo_lite_enterprise.tagline",
    description: "drones_catalog.items.evo_lite_enterprise.description",
    specs: [
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_0.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_0.value" },
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_1.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_1.value" },
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_2.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_2.value" },
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_3.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_3.value" },
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_4.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_4.value" },
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_5.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_5.value" },
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_6.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_6.value" },
      { label: "drones_catalog.items.evo_lite_enterprise.specs.item_7.label", value: "drones_catalog.items.evo_lite_enterprise.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.evo_lite_enterprise.highlights.item_0",
      "drones_catalog.items.evo_lite_enterprise.highlights.item_1",
      "drones_catalog.items.evo_lite_enterprise.highlights.item_2",
      "drones_catalog.items.evo_lite_enterprise.highlights.item_3",
      "drones_catalog.items.evo_lite_enterprise.highlights.item_4",
      "drones_catalog.items.evo_lite_enterprise.highlights.item_5",
    ],
  },
  {
    slug: "evo-max-4t",
    categorySlug: "multirotor",
    key: "evo_max_4t",
    youtubeId: "IaKUtdAdG5w",
    autelUrl: "https://www.autelrobotics.com/productdetail/evo-max-4t/",
    image: "/drone_images/EVOMax4T.png",
    tagline: "drones_catalog.items.evo_max_4t.tagline",
    description: "drones_catalog.items.evo_max_4t.description",
    specs: [
      { label: "drones_catalog.items.evo_max_4t.specs.item_0.label", value: "drones_catalog.items.evo_max_4t.specs.item_0.value" },
      { label: "drones_catalog.items.evo_max_4t.specs.item_1.label", value: "drones_catalog.items.evo_max_4t.specs.item_1.value" },
      { label: "drones_catalog.items.evo_max_4t.specs.item_2.label", value: "drones_catalog.items.evo_max_4t.specs.item_2.value" },
      { label: "drones_catalog.items.evo_max_4t.specs.item_3.label", value: "drones_catalog.items.evo_max_4t.specs.item_3.value" },
      { label: "drones_catalog.items.evo_max_4t.specs.item_4.label", value: "drones_catalog.items.evo_max_4t.specs.item_4.value" },
      { label: "drones_catalog.items.evo_max_4t.specs.item_5.label", value: "drones_catalog.items.evo_max_4t.specs.item_5.value" },
      { label: "drones_catalog.items.evo_max_4t.specs.item_6.label", value: "drones_catalog.items.evo_max_4t.specs.item_6.value" },
      { label: "drones_catalog.items.evo_max_4t.specs.item_7.label", value: "drones_catalog.items.evo_max_4t.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.evo_max_4t.highlights.item_0",
      "drones_catalog.items.evo_max_4t.highlights.item_1",
      "drones_catalog.items.evo_max_4t.highlights.item_2",
      "drones_catalog.items.evo_max_4t.highlights.item_3",
      "drones_catalog.items.evo_max_4t.highlights.item_4",
      "drones_catalog.items.evo_max_4t.highlights.item_5",
    ],
  },
  {
    slug: "evo-max-4n",
    categorySlug: "multirotor",
    key: "evo_max_4n",
    youtubeId: "Cv5q5dgtz0U",
    autelUrl: "https://www.autelrobotics.com/productdetail/evo-max-4n/",
    image: "/drone_images/EVOMax4N.png",
    tagline: "drones_catalog.items.evo_max_4n.tagline",
    description: "drones_catalog.items.evo_max_4n.description",
    specs: [
      { label: "drones_catalog.items.evo_max_4n.specs.item_0.label", value: "drones_catalog.items.evo_max_4n.specs.item_0.value" },
      { label: "drones_catalog.items.evo_max_4n.specs.item_1.label", value: "drones_catalog.items.evo_max_4n.specs.item_1.value" },
      { label: "drones_catalog.items.evo_max_4n.specs.item_2.label", value: "drones_catalog.items.evo_max_4n.specs.item_2.value" },
      { label: "drones_catalog.items.evo_max_4n.specs.item_3.label", value: "drones_catalog.items.evo_max_4n.specs.item_3.value" },
      { label: "drones_catalog.items.evo_max_4n.specs.item_4.label", value: "drones_catalog.items.evo_max_4n.specs.item_4.value" },
      { label: "drones_catalog.items.evo_max_4n.specs.item_5.label", value: "drones_catalog.items.evo_max_4n.specs.item_5.value" },
      { label: "drones_catalog.items.evo_max_4n.specs.item_6.label", value: "drones_catalog.items.evo_max_4n.specs.item_6.value" },
      { label: "drones_catalog.items.evo_max_4n.specs.item_7.label", value: "drones_catalog.items.evo_max_4n.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.evo_max_4n.highlights.item_0",
      "drones_catalog.items.evo_max_4n.highlights.item_1",
      "drones_catalog.items.evo_max_4n.highlights.item_2",
      "drones_catalog.items.evo_max_4n.highlights.item_3",
      "drones_catalog.items.evo_max_4n.highlights.item_4",
      "drones_catalog.items.evo_max_4n.highlights.item_5",
    ],
  },
  {
    slug: "autel-alpha",
    categorySlug: "multirotor",
    key: "autel_alpha",
    youtubeId: "gUuwPvnr8ek",
    autelUrl: "https://www.autelrobotics.com/productdetail/autel-alpha/",
    image: "/drone_images/AutelAlpha.png",
    tagline: "drones_catalog.items.autel_alpha.tagline",
    description: "drones_catalog.items.autel_alpha.description",
    specs: [
      { label: "drones_catalog.items.autel_alpha.specs.item_0.label", value: "drones_catalog.items.autel_alpha.specs.item_0.value" },
      { label: "drones_catalog.items.autel_alpha.specs.item_1.label", value: "drones_catalog.items.autel_alpha.specs.item_1.value" },
      { label: "drones_catalog.items.autel_alpha.specs.item_2.label", value: "drones_catalog.items.autel_alpha.specs.item_2.value" },
      { label: "drones_catalog.items.autel_alpha.specs.item_3.label", value: "drones_catalog.items.autel_alpha.specs.item_3.value" },
      { label: "drones_catalog.items.autel_alpha.specs.item_4.label", value: "drones_catalog.items.autel_alpha.specs.item_4.value" },
      { label: "drones_catalog.items.autel_alpha.specs.item_5.label", value: "drones_catalog.items.autel_alpha.specs.item_5.value" },
      { label: "drones_catalog.items.autel_alpha.specs.item_6.label", value: "drones_catalog.items.autel_alpha.specs.item_6.value" },
      { label: "drones_catalog.items.autel_alpha.specs.item_7.label", value: "drones_catalog.items.autel_alpha.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.autel_alpha.highlights.item_0",
      "drones_catalog.items.autel_alpha.highlights.item_1",
      "drones_catalog.items.autel_alpha.highlights.item_2",
      "drones_catalog.items.autel_alpha.highlights.item_3",
      "drones_catalog.items.autel_alpha.highlights.item_4",
      "drones_catalog.items.autel_alpha.highlights.item_5",
    ],
  },
  {
    slug: "evo-ii-enterprise-v3",
    categorySlug: "multirotor",
    key: "evo_ii_enterprise_v3",
    youtubeId: "FUFWPaUa2T4",
    autelUrl: "https://www.autelrobotics.com/productdetail/evo-ii-enterprise-drones/",
    image: "/drone_images/EVOIIEnterpriseV3.png",
    tagline: "drones_catalog.items.evo_ii_enterprise_v3.tagline",
    description: "drones_catalog.items.evo_ii_enterprise_v3.description",
    specs: [
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_0.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_0.value" },
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_1.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_1.value" },
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_2.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_2.value" },
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_3.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_3.value" },
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_4.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_4.value" },
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_5.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_5.value" },
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_6.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_6.value" },
      { label: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_7.label", value: "drones_catalog.items.evo_ii_enterprise_v3.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.evo_ii_enterprise_v3.highlights.item_0",
      "drones_catalog.items.evo_ii_enterprise_v3.highlights.item_1",
      "drones_catalog.items.evo_ii_enterprise_v3.highlights.item_2",
      "drones_catalog.items.evo_ii_enterprise_v3.highlights.item_3",
      "drones_catalog.items.evo_ii_enterprise_v3.highlights.item_4",
      "drones_catalog.items.evo_ii_enterprise_v3.highlights.item_5",
    ],
  },
  {
    slug: "evo-ii-dual-640t-v3",
    categorySlug: "multirotor",
    key: "evo_ii_dual_640t_v3",
    youtubeId: "CHEcexSCukk",
    autelUrl: "https://www.autelrobotics.com/productdetail/evo-ii-dual-640t-drones/",
    image: "/drone_images/EVOIIDual640TV3.png",
    tagline: "drones_catalog.items.evo_ii_dual_640t_v3.tagline",
    description: "drones_catalog.items.evo_ii_dual_640t_v3.description",
    specs: [
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_0.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_0.value" },
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_1.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_1.value" },
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_2.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_2.value" },
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_3.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_3.value" },
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_4.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_4.value" },
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_5.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_5.value" },
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_6.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_6.value" },
      { label: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_7.label", value: "drones_catalog.items.evo_ii_dual_640t_v3.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.evo_ii_dual_640t_v3.highlights.item_0",
      "drones_catalog.items.evo_ii_dual_640t_v3.highlights.item_1",
      "drones_catalog.items.evo_ii_dual_640t_v3.highlights.item_2",
      "drones_catalog.items.evo_ii_dual_640t_v3.highlights.item_3",
      "drones_catalog.items.evo_ii_dual_640t_v3.highlights.item_4",
      "drones_catalog.items.evo_ii_dual_640t_v3.highlights.item_5",
    ],
  },
  {
    slug: "evo-ii-rtk-series-v3",
    categorySlug: "multirotor",
    key: "evo_ii_rtk_v3",
    youtubeId: "XC-Iv2bEqOo",
    autelUrl: "https://www.autelrobotics.com/productdetail/evo-ii-rtk-series-drones/",
    image: "/drone_images/EVOIIRTKV3.png",
    tagline: "drones_catalog.items.evo_ii_rtk_v3.tagline",
    description: "drones_catalog.items.evo_ii_rtk_v3.description",
    specs: [
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_0.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_0.value" },
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_1.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_1.value" },
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_2.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_2.value" },
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_3.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_3.value" },
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_4.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_4.value" },
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_5.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_5.value" },
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_6.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_6.value" },
      { label: "drones_catalog.items.evo_ii_rtk_v3.specs.item_7.label", value: "drones_catalog.items.evo_ii_rtk_v3.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.evo_ii_rtk_v3.highlights.item_0",
      "drones_catalog.items.evo_ii_rtk_v3.highlights.item_1",
      "drones_catalog.items.evo_ii_rtk_v3.highlights.item_2",
      "drones_catalog.items.evo_ii_rtk_v3.highlights.item_3",
      "drones_catalog.items.evo_ii_rtk_v3.highlights.item_4",
      "drones_catalog.items.evo_ii_rtk_v3.highlights.item_5",
    ],
  },
  {
    slug: "evo-ii-pro-v3",
    categorySlug: "multirotor",
    key: "evo_ii_pro_v3",
    youtubeId: "XDiWQps-Rxc",
    autelUrl: "https://www.autelrobotics.com/productdetail/evo-ii-pro-drones/",
    image: "/drone_images/EVOIIProV3.png",
    tagline: "drones_catalog.items.evo_ii_pro_v3.tagline",
    description: "drones_catalog.items.evo_ii_pro_v3.description",
    specs: [
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_0.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_0.value" },
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_1.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_1.value" },
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_2.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_2.value" },
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_3.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_3.value" },
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_4.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_4.value" },
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_5.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_5.value" },
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_6.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_6.value" },
      { label: "drones_catalog.items.evo_ii_pro_v3.specs.item_7.label", value: "drones_catalog.items.evo_ii_pro_v3.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.evo_ii_pro_v3.highlights.item_0",
      "drones_catalog.items.evo_ii_pro_v3.highlights.item_1",
      "drones_catalog.items.evo_ii_pro_v3.highlights.item_2",
      "drones_catalog.items.evo_ii_pro_v3.highlights.item_3",
      "drones_catalog.items.evo_ii_pro_v3.highlights.item_4",
      "drones_catalog.items.evo_ii_pro_v3.highlights.item_5",
    ],
  },
  // ———— eVTOL ————
  {
    slug: "dragonfish-25",
    categorySlug: "evtol",
    key: "dragonfish_25",
    youtubeId: "k6HQ9dloBOo",
    autelUrl: "https://www.autelrobotics.com/productdetail/dragonfish-25/",
    image: "/drone_images/Dragonfish25.png",
    tagline: "drones_catalog.items.dragonfish_25.tagline",
    description: "drones_catalog.items.dragonfish_25.description",
    specs: [
      { label: "drones_catalog.items.dragonfish_25.specs.item_0.label", value: "drones_catalog.items.dragonfish_25.specs.item_0.value" },
      { label: "drones_catalog.items.dragonfish_25.specs.item_1.label", value: "drones_catalog.items.dragonfish_25.specs.item_1.value" },
      { label: "drones_catalog.items.dragonfish_25.specs.item_2.label", value: "drones_catalog.items.dragonfish_25.specs.item_2.value" },
      { label: "drones_catalog.items.dragonfish_25.specs.item_3.label", value: "drones_catalog.items.dragonfish_25.specs.item_3.value" },
      { label: "drones_catalog.items.dragonfish_25.specs.item_4.label", value: "drones_catalog.items.dragonfish_25.specs.item_4.value" },
      { label: "drones_catalog.items.dragonfish_25.specs.item_5.label", value: "drones_catalog.items.dragonfish_25.specs.item_5.value" },
      { label: "drones_catalog.items.dragonfish_25.specs.item_6.label", value: "drones_catalog.items.dragonfish_25.specs.item_6.value" },
      { label: "drones_catalog.items.dragonfish_25.specs.item_7.label", value: "drones_catalog.items.dragonfish_25.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.dragonfish_25.highlights.item_0",
      "drones_catalog.items.dragonfish_25.highlights.item_1",
      "drones_catalog.items.dragonfish_25.highlights.item_2",
      "drones_catalog.items.dragonfish_25.highlights.item_3",
      "drones_catalog.items.dragonfish_25.highlights.item_4",
      "drones_catalog.items.dragonfish_25.highlights.item_5",
    ],
  },
  {
    slug: "dragonfish-pro",
    categorySlug: "evtol",
    key: "dragonfish_pro",
    youtubeId: "k6HQ9dloBOo",
    autelUrl: "https://www.autelrobotics.com/productdetail/dragonfish-pro/",
    image: "/drone_images/DragonfishPro.png",
    tagline: "drones_catalog.items.dragonfish_pro.tagline",
    description: "drones_catalog.items.dragonfish_pro.description",
    specs: [
      { label: "drones_catalog.items.dragonfish_pro.specs.item_0.label", value: "drones_catalog.items.dragonfish_pro.specs.item_0.value" },
      { label: "drones_catalog.items.dragonfish_pro.specs.item_1.label", value: "drones_catalog.items.dragonfish_pro.specs.item_1.value" },
      { label: "drones_catalog.items.dragonfish_pro.specs.item_2.label", value: "drones_catalog.items.dragonfish_pro.specs.item_2.value" },
      { label: "drones_catalog.items.dragonfish_pro.specs.item_3.label", value: "drones_catalog.items.dragonfish_pro.specs.item_3.value" },
      { label: "drones_catalog.items.dragonfish_pro.specs.item_4.label", value: "drones_catalog.items.dragonfish_pro.specs.item_4.value" },
      { label: "drones_catalog.items.dragonfish_pro.specs.item_5.label", value: "drones_catalog.items.dragonfish_pro.specs.item_5.value" },
      { label: "drones_catalog.items.dragonfish_pro.specs.item_6.label", value: "drones_catalog.items.dragonfish_pro.specs.item_6.value" },
      { label: "drones_catalog.items.dragonfish_pro.specs.item_7.label", value: "drones_catalog.items.dragonfish_pro.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.dragonfish_pro.highlights.item_0",
      "drones_catalog.items.dragonfish_pro.highlights.item_1",
      "drones_catalog.items.dragonfish_pro.highlights.item_2",
      "drones_catalog.items.dragonfish_pro.highlights.item_3",
      "drones_catalog.items.dragonfish_pro.highlights.item_4",
      "drones_catalog.items.dragonfish_pro.highlights.item_5",
    ],
  },
  {
    slug: "dragonfish-standard",
    categorySlug: "evtol",
    key: "dragonfish_standard",
    youtubeId: "k6HQ9dloBOo",
    autelUrl: "https://www.autelrobotics.com/productdetail/dragonfish-standard/",
    image: "/drone_images/DragonfishStandart.png",
    tagline: "drones_catalog.items.dragonfish_standard.tagline",
    description: "drones_catalog.items.dragonfish_standard.description",
    specs: [
      { label: "drones_catalog.items.dragonfish_standard.specs.item_0.label", value: "drones_catalog.items.dragonfish_standard.specs.item_0.value" },
      { label: "drones_catalog.items.dragonfish_standard.specs.item_1.label", value: "drones_catalog.items.dragonfish_standard.specs.item_1.value" },
      { label: "drones_catalog.items.dragonfish_standard.specs.item_2.label", value: "drones_catalog.items.dragonfish_standard.specs.item_2.value" },
      { label: "drones_catalog.items.dragonfish_standard.specs.item_3.label", value: "drones_catalog.items.dragonfish_standard.specs.item_3.value" },
      { label: "drones_catalog.items.dragonfish_standard.specs.item_4.label", value: "drones_catalog.items.dragonfish_standard.specs.item_4.value" },
      { label: "drones_catalog.items.dragonfish_standard.specs.item_5.label", value: "drones_catalog.items.dragonfish_standard.specs.item_5.value" },
      { label: "drones_catalog.items.dragonfish_standard.specs.item_6.label", value: "drones_catalog.items.dragonfish_standard.specs.item_6.value" },
      { label: "drones_catalog.items.dragonfish_standard.specs.item_7.label", value: "drones_catalog.items.dragonfish_standard.specs.item_7.value" },
    ],
    highlights: [
      "drones_catalog.items.dragonfish_standard.highlights.item_0",
      "drones_catalog.items.dragonfish_standard.highlights.item_1",
      "drones_catalog.items.dragonfish_standard.highlights.item_2",
      "drones_catalog.items.dragonfish_standard.highlights.item_3",
      "drones_catalog.items.dragonfish_standard.highlights.item_4",
      "drones_catalog.items.dragonfish_standard.highlights.item_5",
    ],
  },
];

export function getDroneBySlug(categorySlug, droneSlug) {
  return DRONES_DATA.find(
    (d) => d.categorySlug === categorySlug && d.slug === droneSlug
  ) || null;
}

export function getDronesForCategory(categorySlug) {
  return DRONES_DATA.filter((d) => d.categorySlug === categorySlug);
}

export function getAllDroneSlugs() {
  return DRONES_DATA.map((d) => ({
    categorySlug: d.categorySlug,
    droneSlug: d.slug,
  }));
}
